/** Official Coin MBX logo (served from `frontend/public/assets/Logo.png`). */
export const BRAND_LOGO_SRC = "/assets/Logo.png";
/** Brand blue behind logo — matches mobile `AppLogo` / app icon. */
export const BRAND_LOGO_BLUE = "#0047AB";
